module.exports = __webpack_public_path__ + "static/media/temperature-up.c146505a.svg";